import { useTranslation } from "react-i18next";

import { useAuth } from "@/shared/stores/useAuth";
import OwnedDeckCardList from "@/cards/common/component/deck-library/OwnedDeckCardList";
import { useDeckCardTalentExpandShare } from "@/cards/common/component/deck-library/useDeckCardTalentExpandShare";
import {
  DEMO_CARD_NAVIGATION,
  getDemoCardIdFromCard,
  mapDemoMainCardResponseToPublishedCard,
} from "@/cards/common/utils/app-deck/ownedDeckCardList.utils";

/** User purchased Demo Cards list (cover, episodes, listing). */
const DemoCardUserPage = () => {
  const { t } = useTranslation();
  const { userInfo } = useAuth();
  const { onExpandShare, shareModal } = useDeckCardTalentExpandShare({
    cardKind: "demo",
  });

  return (
    <>
      <OwnedDeckCardList
        deckCardType="Demo_Card"
        viewMode="user"
        purchaseFilter="purchased"
        navigation={DEMO_CARD_NAVIGATION}
        tabParamKey="demo_tab"
        tabParamValue="purchased"
        titleLabel={t("demo_card", {
          ns: "taascard",
          defaultValue: "Demo Card",
        })}
        emptyTitle={t("no_purchased_cards_title")}
        emptySubtitle={t("no_purchased_cards_subtitle")}
        showTalentFilter
        enabled={Boolean(userInfo?.id)}
        onExpandShare={onExpandShare}
        deckCardShareKind="demo"
        mapFetchedMainCard={mapDemoMainCardResponseToPublishedCard}
        secondaryUrlParam={{
          key: "demoCardId",
          getValue: (card) => getDemoCardIdFromCard(card),
        }}
      />
      {shareModal}
    </>
  );
};

export default DemoCardUserPage;
